import { useMemo } from 'react';

import { useAppSelector } from '~/store';

import AlbumSearchResults from './AlbumSearchResults';
import PaperSearchResults from './PaperSearchResults';
import { usePaperFacets } from './PaperSearchResults/usePaperFacets';
import { getUserContext } from '../../../../selectors/userSelectors';

const containsAlbumTerm = (query: string) => new RegExp(/\balbums?\b/).test(query);

interface AlbumOrPaperResultsProps {
  searchQuery: string;
  updateStickySidebar: () => void;
}

const AlbumOrPaperResults = ({
  searchQuery,
  updateStickySidebar,
}: AlbumOrPaperResultsProps): JSX.Element | null => {
  const isAlbumSearch = containsAlbumTerm(searchQuery);
  const paperFacets = usePaperFacets(searchQuery);
  const userContext = useAppSelector(getUserContext);

  // We only check the user's experiment if the searchQuery matches paper or album terms
  const isUnderTest = useMemo(
    () => !!(isAlbumSearch || paperFacets) && !!userContext,
    [paperFacets, isAlbumSearch, userContext]
  );

  if (!isUnderTest) return null;

  if (isAlbumSearch) {
    return (
      <AlbumSearchResults searchQuery={searchQuery} updateStickySidebar={updateStickySidebar} />
    );
  }

  return paperFacets ? (
    <PaperSearchResults
      searchQuery={searchQuery}
      facets={paperFacets}
      updateStickySidebar={updateStickySidebar}
    />
  ) : null;
};

export default AlbumOrPaperResults;
